import {
  AppBar,
  Toolbar,
  IconButton,
  Box,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
} from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import QrCodeIcon from "@mui/icons-material/QrCode";
import SettingsIcon from "@mui/icons-material/Settings";
import Logo from "../assets/Logo_Eldan.png";
import { useState } from "react";

function Navbar() {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setDrawerOpen(open);
  };

  const menuItems = [
    { text: "בית", icon: <HomeIcon /> },
    { text: "סריקת QR", icon: <QrCodeIcon /> },
    { text: "הגדרות", icon: <SettingsIcon /> },
  ];

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          backgroundColor: "#e6f3ff",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        }}
      >
        <Toolbar sx={{ minHeight: "56px" }}>
          <Box
            sx={{
              flexGrow: 1,
              display: "flex",
              justifyContent: "center",
              py: 1,
            }}
            data-testid="logo-container"
          >
            <img
              src={Logo}
              alt="Eldan Logo"
              style={{
                height: "56px",
                objectFit: "contain",
              }}
            />
          </Box>
        </Toolbar>
      </AppBar>

      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={toggleDrawer(false)}
        sx={{
          "& .MuiDrawer-paper": {
            width: "80%",
            maxWidth: "300px",
            backgroundColor: "#fff",
          },
        }}
      >
        <Box
          sx={{
            width: "100%",
            pt: 2,
            pb: 1,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <img
            src={Logo}
            alt="Eldan Logo"
            style={{
              height: "40px",
              objectFit: "contain",
            }}
          />
        </Box>
        <Divider />
        <List sx={{ direction: "rtl" }}>
          {menuItems.map((item) => (
            <ListItem
              button
              key={item.text}
              sx={{
                py: 2,
                "&:hover": {
                  backgroundColor: "rgba(0, 102, 153, 0.08)",
                },
              }}
            >
              <ListItemIcon sx={{ minWidth: 40 }}>{item.icon}</ListItemIcon>
              <ListItemText
                primary={item.text}
                sx={{
                  "& .MuiListItemText-primary": {
                    fontFamily: "Rubik, sans-serif",
                    fontWeight: 500,
                  },
                }}
              />
            </ListItem>
          ))}
        </List>
      </Drawer>
      <Toolbar />
    </>
  );
}

export default Navbar;
